import { ApiSuccessResponse } from "../../@types";
import { apiSlice } from "../../app/api/apiSlice";
import {
  DashboardPayload,
  DashboardStats,
  SuperAdminDashboardPayload,
  SuperAdminDashboardStats,
} from "./@types";

export const expenseApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCompanyDashboardStats: builder.mutation<
      DashboardStats,
      DashboardPayload
    >({
      query: (data) => ({
        url: "/v1/dashboard/company",
        method: "POST",
        body: { ...data },
      }),
    }),
    getSuperAdminDashboardStats: builder.mutation<
      ApiSuccessResponse<SuperAdminDashboardStats>,
      SuperAdminDashboardPayload
    >({
      query: (data) => ({
        url: "/v1/dashboard/central",
        method: "POST",
        body: { ...data },
      }),
    }),
  }),
});

export const {
  useGetCompanyDashboardStatsMutation,
  useGetSuperAdminDashboardStatsMutation,
} = expenseApiSlice;
